<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                title="返回"
                @back="goBack"
                content="新增产品信息"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-tabs type="card" :stretch="true" :before-leave="leaveTabOnclick">
          <el-tab-pane label="基本信息" name="0">
            <ProductDetailBasicModule
              @updateFrame="updateFrameStatus"
              :product-id="product_id"
              :operate-type="operate_type"
              ref="ProductDetailBasicModule"
            />
          </el-tab-pane>
          <el-tab-pane label="详情信息" name="1">
            <ProductDetailContentModule
              :product-id="product_id"
              :operate-type="operate_type"
              ref="ProductDetailContentModule"
            />
          </el-tab-pane>
          <el-tab-pane label="SKU" name="2">
            <ProductDetailSkuModule
              :product-id="product_id"
              :operate-type="operate_type"
              ref="ProductDetailSkuModule"
            />
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// 产品详情 - 容器
import ProductDetailBasicModule from "../detail/module/ProductDetailBasicModule";
import ProductDetailContentModule from "../detail/module/ProductDetailContentModule";

import ProductSkuListModule from "../index/module/ProductSkuListModule.vue";
import ProductDetailSkuModule from "../index/module/ProductDetailSkuModule.vue";

export default {
  name: "ProductAddNewView",
  components: {
    ProductDetailBasicModule,
    ProductDetailContentModule,
    ProductSkuListModule,
    ProductDetailSkuModule,
  },
  data() {
    return {
      loading: false,
      product_id: "",
      operate_type: "new",
    };
  },
  methods: {
    updateFrameStatus(value) {
      this.product_id = value;
      this.operate_type = "edit";
      // console.log("获取到子组件传值:", value)
    },
    leaveTabOnclick(activeName, oldActiveName) {
      if (activeName != "0") {
        // eslint-disable-next-line no-console
        console.log(activeName, oldActiveName);
        if (this.product_id !== undefined && this.product_id.length > 0) {
          return true;
        } else {
          this.$message.warning("请先添加产品基本信息");
          return false;
        }
      }
    },
    switchSku(value) {
      let _me = this;
      _me.is_list = !_me.is_list;
      _me.sku_id = value;
    },
    goBack() {
      // 返回上一级路由
      this.$router.go(-1);
      // 跳转回指定路由
      // this.$router.push('/product-detail-mount')
    },
  },
};
</script>

<style scoped></style>